import { useState, useEffect, useRef } from "react";
import { ChevronDown } from "lucide-react";

/**
 * Reusable dropdown filter button.
 * options: [{ key, labelKey, Icon? }]
 * value: current selected key (null = "all")
 */
export function FilterDropdown({ options, value, onChange, t, testId }) {
  const [open, setOpen] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    const h = (e) => { if (ref.current && !ref.current.contains(e.target)) setOpen(false); };
    document.addEventListener("mousedown", h);
    return () => document.removeEventListener("mousedown", h);
  }, []);

  const active = options.find((o) => o.key === value) || options[0];
  const isFiltered = value !== null && value !== undefined;

  return (
    <div className="relative" ref={ref}>
      <button
        onClick={() => setOpen(!open)}
        data-testid={testId}
        className={`flex items-center gap-1.5 px-3 py-1.5 rounded-sm text-xs font-mono transition-colors border whitespace-nowrap ${
          isFiltered
            ? "bg-brand-primary text-white border-brand-primary"
            : "border-border text-muted-foreground hover:text-foreground hover:border-foreground/20"
        }`}
      >
        {active.Icon && <active.Icon className="w-3 h-3" />}
        <span>{t(active.labelKey)}</span>
        <ChevronDown className={`w-3 h-3 ml-0.5 transition-transform ${open ? "rotate-180" : ""}`} />
      </button>
      {open && (
        <div className="absolute top-full mt-1 right-0 z-50 min-w-[9rem] rounded-md border border-border bg-background shadow-xl py-1 overflow-hidden">
          {options.map(({ key, labelKey, Icon }) => (
            <button
              key={String(key)}
              data-testid={`${testId}-opt-${key || "all"}`}
              onClick={() => { onChange(key); setOpen(false); }}
              className={`w-full flex items-center gap-2 px-3 py-1.5 text-xs font-mono text-left transition-colors ${
                value === key
                  ? "bg-brand-primary/10 text-brand-primary"
                  : "text-muted-foreground hover:bg-secondary/50 hover:text-foreground"
              }`}
            >
              {Icon && <Icon className="w-3 h-3 flex-shrink-0" />}
              {t(labelKey)}
            </button>
          ))}
        </div>
      )}
    </div>
  );
}
